import { COVERAGE_TABS } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import { createCoverageSelector, createCoverageParamsSelector } from '../../../common/coverage/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getOSCoverage = (store) => store.apps.analytics.rdc.coverage.os;

export const osCoverageSelector = createCoverageSelector({
  coverageStore: getOSCoverage,
  source: 'rdc',
  productSubArea: TRACKING_SUB_AREA[COVERAGE_TABS.os.trackEvent],
});

export const getParams = createCoverageParamsSelector(
  filtersSelectors.getCoverageFiltersParams,
  getOSCoverage,
);
